export default __webpack_public_path__ + "static/media/mdi_sparkles-outline.9d23ea56.svg";